<template>
  <div class="product-info__color">
    <color-swatch :options="options" :parentAttribute="parentAttribute" :defaultSelected="defaultSelected" @filterSelected="change($event)"></color-swatch>
  </div>
</template>

<script>
import ColorSwatch from './ColorSwatch/ColorSwatch'

export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    parentAttribute: {
      type: String,
      required: true
    },
    filterActive: {
      type: Object,
      required: true
    },
    defaultSelected: {
      type: String | Number,
      required: false,
      default: null
    },
    filterCode: {
      type: String,
      default: 'size'
    }
  },
  components: {
    ColorSwatch
  },
  data () {
    return {
      colorSelectedLabel: null
    }
  },
  methods: {
    change (newValues) {
      this.colorSelectedLabel = newValues.value.label
      this.$emit('filterSelected', this.getFilterCompose(newValues.value.value_index))
    },
    getFilterCompose (newValues) {
      return { type: this.parentAttribute, value: newValues }
    }
  }
}
</script>
